export const layoutCopy = {
  nav: {
    catalog: "Katalog",
    blog: "Blog",
    topics: "Topik",
    openMenu: "Buka menu navigasi",
    closeMenu: "Tutup menu navigasi",
    mainLabel: "Navigasi utama",
  },
  footer: {
    about:
      "Platform belajar automation, AI agent, dan SaaS berbahasa Indonesia oleh Aji Prakoso.",
    productsTitle: "Belajar",
    topicsTitle: "Topik",
    supportTitle: "Bantuan",
    contact: "Hubungi kami",
    rights: (year: number) => `© ${year} AI Class. Semua hak dilindungi.`,
  },
  faq: {
    eyebrow: "FAQ",
    title: "Pertanyaan yang sering diajukan",
  },
  topics: {
    eyebrow: "Jelajahi topik",
    title: "Belajar sesuai minat Anda",
    productsTitle: (name: string) => `Kelas & produk ${name}`,
    articlesTitle: (name: string) => `Artikel ${name}`,
    empty: "Konten untuk topik ini sedang disiapkan. Sementara itu, lihat katalog dan blog kami.",
    notFoundTitle: "Topik tidak ditemukan",
  },
} as const;
